<template>
  <el-dialog :visible.sync="visible" title="设置支付密码" width="420px" @close="onClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="支付密码" prop="password">
        <el-input v-model="form.password" show-password placeholder="请输入支付密码" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible=false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">保存</el-button>
    </div>
  </el-dialog>
  </template>

<script>
export default {
  name: 'PayPwdSetDialog',
  data() {
    return {
      visible: false,
      loading: false,
      form: { password: '' },
      rules: { password: [{ required: true, message: '请输入支付密码', trigger: 'blur' }] }
    }
  },
  methods: {
    open() {
      this.form.password = '';
      this.visible = true;
    },
    onClose() {
      this.form.password = '';
      this.loading = false;
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          await this.$http({ url: '/wallet/paypwd/set', method: 'POST', data: { password: this.form.password } });
          this.$message.success('支付密码设置成功');
          this.visible = false;
          this.$emit('complete');
        } catch (e) {
          let _ = e;
        } finally {
          this.loading = false;
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer { text-align: right; }
</style>
